import { apiFetch } from "@/utils";

function getProcedures() {
  return apiFetch("procdyn/procedures");
}

function getProcParams(procId) {
  return apiFetch("procdyn/params?procId=" + procId);
}

function execProcedure(procId, params = {}) {
  return apiFetch("procdyn/exec?procId=" + procId + "&jsonParams=" + JSON.stringify(params));
}

export default { getProcedures, getProcParams, execProcedure }
export { getProcedures, getProcParams, execProcedure }



// WEBPACK FOOTER //
// ./src/utils/procDyn.js